import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-order-line-ms',
  templateUrl: './order-line-ms.component.html',
  styleUrls: ['./order-line-ms.component.css']
})
export class OrderLineMsComponent implements OnInit {
    argType;

    headNo;

    lineNo;

    public setting?: Setting;

    public itemsListModels: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.argType = this.stateService.getStateParams()['argtype'];
        this.headNo = this.stateService.getStateParams()['headno'];
        this.lineNo = this.stateService.getStateParams()['lineno'];
    }

    private async loadSetting() {
        if (!!this.argType && !!this.headNo && !!this.lineNo) {
            this.setting = (await this.datatask.Post(1096, {
                argtype: this.argType,
                headno: this.headNo,
                lineno: this.lineNo
            }))[0];
        }
    }

    private async loadModels() {
        if (!this.setting) return;

        return this.itemsListModels = await this.datatask.Post(1097, this.setting);
    }

    private async init() {
        await this.loadSetting();
        this.loadModels();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    argtype: string;
    headno: string;
    lineno: string;
    filtervalue: string;
    webpage_heading: string;
    show_setting: string;
}
